import React from "react";
import {
    ConsentFormCache,
    EmailSignatureCache,
    IACLEmail,
    TLocationAddress,
    TOfficeManager,
    TOffices,
    TRequestedService,
} from "intake_shared/src/types";
import { DepartmentCache } from "../store/cache/requested_service";

export const CacheContext = React.createContext<
    | {
          offices?: TOffices;
          office_managers?: TOfficeManager;
          location_address?: TLocationAddress;
          allUserRoles?: IACLEmail[];
          allDepartmentAndServices?: DepartmentCache;
          updateOffices: (offices: TOffices) => void;
          updateOfficeManager: (office_managers: TOfficeManager) => void;
          requestedServices?: TRequestedService;
          departments?: DepartmentCache;
          consentForms?: ConsentFormCache;
          emailSignatures?: EmailSignatureCache;
          updateRequestedServices: (requestedServices: TRequestedService) => void;
          updateDepartments: (departments: DepartmentCache) => void;
          updateConsentForms: (consents: ConsentFormCache) => void;
          updateEmailSignatures: (signatures: EmailSignatureCache) => void;
          updateAllDeptAndServices: (
              departmentsAndServices: DepartmentCache
          ) => void;
          updateLocationAddress: (locationAddress: TLocationAddress) => void;
      }
    | undefined
>(undefined);
